import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ButtonComponent from '../Button.component';
import BaseAlertComponent, {
  BaseAlert2Props,
  StyledBaseAlertBodyIcon,
} from './BaseAlert.component';
import WarningIcon from '../Icons/Warning.icon';
import { ALERT_ACTION_ENUM } from '../../types/action.types';
import { useModalManager } from '../../hooks/ModalManager.hook';

const WARNING_ICON_SIZE = 42;

const StyledWarningAlert = styled.div`
  ${StyledBaseAlertBodyIcon} {
    color: ${({ theme }) => theme.colors.ORANGE.O400};
  }
`;

const WarningAlertComponent = ({
  header,
  onClose,
  children,
}: BaseAlert2Props) => {
  const { t } = useTranslation();
  const { closeModal } = useModalManager();

  const handleClose = (action: ALERT_ACTION_ENUM) => {
    onClose && onClose(action);
    closeModal();
  };

  return (
    <StyledWarningAlert>
      <BaseAlertComponent
        header={header || t('Warning')}
        icon={<WarningIcon width={WARNING_ICON_SIZE} height={WARNING_ICON_SIZE} />}
        footer={
          <React.Fragment>
            <ButtonComponent
              handleClick={() => handleClose(ALERT_ACTION_ENUM.YES)}
            >
              {t('Yes')}
            </ButtonComponent>
            <ButtonComponent
              handleClick={() => handleClose(ALERT_ACTION_ENUM.NO)}
            >
              {t('No')}
            </ButtonComponent>
          </React.Fragment>
        }
        onClose={() => handleClose(ALERT_ACTION_ENUM.NO)}
      >
        {children}
      </BaseAlertComponent>
    </StyledWarningAlert>
  );
};

export default WarningAlertComponent;
